import React from 'react';
import { Flex } from 'grid-styled';
import styled from 'styled-components';
import { string, func, oneOfType } from 'prop-types';
import DropDownMenu from 'material-ui/DropDownMenu';
import { SmallNote } from './Text';

const Container = Flex.extend`
  display: inline-flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
`;

const Descriptor = SmallNote.extend`
  position: absolute;
  top: 1px;
  left: 0px;
`;

// FIXME: what’s with the left margin being -24px?
const DropDown = styled(DropDownMenu).attrs({
  selectedMenuItemStyle: ({ theme }) => ({ color: theme.colors.gold500 }),
})`
  margin-bottom: 4px !important;
  padding-top: 4px;
  margin-left: -24px !important;

  & > * {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')} !important;
  }
`;

const DropDownTitled = ({ title, ...rest }) => (
  <Container>
    {title ? (
      typeof title === 'string' ? (
        <Descriptor>{title}</Descriptor>
      ) : (
        title()
      )
    ) : null}
    <DropDown {...rest} />
  </Container>
);

DropDownTitled.propTypes = {
  title: oneOfType([string, func]),
};

export default DropDownTitled;



// WEBPACK FOOTER //
// ./src/components/DropDownTitled.jsx